import React from 'react';
import NavBar from '../../components/Navbar/NavBar';
import FooterOne from '../../components/Footer/Footer';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, Button, Container, Link, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade } from 'swiper/modules';
import { donateImages } from "../../utils/BeadsData";

const DonatePage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box>
      <NavBar />
      <Box
        sx={{
          mt: 6,
          backgroundImage: 'url("/assets/img/donate/donate-cover.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '100vh',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant={isMobile ? 'h3' : 'h1'} component="h1"
          sx={{
            position: 'absolute',
            color: '#ffffff',
            textShadow: '2px 2px 8px #000000',
            fontWeight: 'bold',
            fontSize: { xs: '2rem', sm: '4rem', md: '6rem' }
          }}
        >
          HOW YOU CAN HELP
        </Typography>
      </Box>

      <Container sx={{ py: 4 }}>
        <Grid container spacing={3}>

          <Typography variant="body1" align="center" sx={{ my: 4, mx: 2, fontSize: 'large', fontWeight: 'bold' }}>
            Thank you for your generous decision to help BEADS for Education! Here are some ways you can help support the women of Kenya.
          </Typography>

          <Grid item xs={12} md={6}>

            <Typography paragraph>
              You can sponsor a girl's education by making a donation, which empowers her to attend school and permanently transform her life.
            </Typography>
            <Swiper
              modules={[Autoplay, EffectFade]}
              // spaceBetween={isMobile ? 10 : 50}
              // slidesPerView={1}
              // navigation={!isMobile}
              effect="fade"
              autoplay={{ delay: 4000, disableOnInteraction: false }}
              loop={true}
              style={{
                width: isMobile ? 'calc(100% - 10px)' : '95%',
                height: 'auto',
                borderRadius: '1.2rem',
                marginRight: '1rem'
              }}
              sx={{
                '.swiper-slide img': {
                  height: isMobile ? '240px' : '480px', // reduced height on mobile
                  objectFit: 'cover',
                  // borderRadius: theme.shape.borderRadius,
                }
              }}
            >
              {donateImages.map((image, index) => (
                <SwiperSlide key={index}>
                  <Box sx={{ position: 'relative' }}>
                    <img src={image.src} alt={image.alt}
                      style={{ width: '100%', height: '480px', objectFit: 'cover', borderRadius: theme.shape.borderRadius }} />
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>
          </Grid>

          <Grid item xs={12} md={6} sx={{ mt: 5 }}>

            <Typography variant="body1" align="center" sx={{ my: 4, mx: 2, fontSize: 'larger', fontWeight: 'bold' }}>
              To make a donation, you can choose among the two options below:
            </Typography>

            <Button variant="contained" href="https://www.paypal.com/donate?token=wCnQHlAZH-6HwbFMYLGCSqiYspzt-HC2ZHu2AnCsXfeEoIdSXy-BGElrwUDRU4DwVqLHB0tPYd67rhT0" target="_blank" rel="noopener noreferrer"
              sx={{
                color: '#fff', backgroundColor: '#f39c12', borderRadius: '3rem', my: 2,
                fontWeight: 'bold', fontSize: 22, textAlign: 'center',
                '&:hover': { transform: 'scale(1.05)' }
              }}
            >
              I WOULD LIKE TO MAKE A ONE-TIME DONATION
            </Button>

            <Button variant="contained" href="https://www.paypal.com/webapps/hermes?token=71S77790A5336280Y&mfid=1708196335109_f6930264e794d&useraction=commit" target="_blank" rel="noopener noreferrer"
              sx={{
                color: '#fff', backgroundColor: '#f39c12', borderRadius: '3rem', my: 2,
                fontWeight: 'bold', fontSize: 20, textAlign: 'center',
                '&:hover': { transform: 'scale(1.05)' }
              }}
            >
              I WOULD LIKE TO MAKE A RECURRING, MONTHLY DONATION
            </Button>

            <Typography variant="body1" align="center" sx={{ my: 2, mx: 2, fontSize: 'large' }}>
              Cancel your recurring donation
              <Link
                href="https://www.paypal.com/myaccount/summary" target="_blank" rel="noopener noreferrer"
                sx={{
                  ml: 1,
                  fontWeight: 'bold',
                  color: 'blue',
                  '&:hover': {
                    color: '#f39c12'
                  }
                }}
              >
                here
              </Link>.
            </Typography>

          </Grid>
        </Grid>

        <Box sx={{ textAlign: 'center', my: 6, p: 3, background: '#f8f9fc', boxShadow: '3px 4px 8px rgba(0,0,0,0.1)' }}>
          <Typography variant="h5">
            YOU CAN ALSO SEND CHECKS TO:
          </Typography>
          <Typography variant="body2">
            BEADS for Education<br />
            P.O. Box 784<br />
            Brookfield, CT 06804<br />
            <br />
            Make your check out to BEADS for Education
          </Typography>
        </Box>

        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Typography variant="h5">
            THERE ARE MORE WAYS TO GET INVOLVED.
          </Typography>

          <Typography paragraph>
            Try visiting our Alternative Gifts & Donations page.
          </Typography>
          <Button className='btn btn-border-base' variant="contained" onClick={() => navigate('/donations-and-alternative-gifts')}
            sx={{
              // backgroundColor: '#f39c12',
              borderRadius: 15,
              // '&:hover': { transform: 'scale(1.05)' }
            }}
          >
            LEARN MORE
          </Button>
        </Box>

      </Container>
      <FooterOne />
    </Box>
  );
};

export default DonatePage;

